<template>
  <div id="iContent">
    <div>
      <div>
        <div v-html="tableData.contents"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        loading: false
      }
    },
    mounted() {
      this.handleSearch()
    },
    methods: {
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/constitution/constitutionOne/3';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = cData.data;
          console.log(that.tableData)
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #iContent {
    width: 100%;
  }

  #iContent>div:nth-child(1) {
    width: 94%;
    margin: 10px 3%;
  }

  #iContent>div:nth-child(1)>div {
    width: 100%;
  }

  #iContent>div:nth-child(1)>div>div:nth-child(1) {
    padding-top: 30px;
    text-align: left;
    line-height: 30px;
    font-size: 18px;
  }

  p {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/qbconstitution.vue